import { InProgressUtilityProgramEnrollment } from '@/reducers/inProgressUtilityProgramEnrollments'
import { programsNewCollection } from '@/reducers/programsNew'
import {
  behavioralEnrollmentCollection,
  chargerEnrollmentCollection,
  thermostatEnrollmentCollection,
  vehicleEnrollmentCollection,
} from '@/reducers/deviceProgramEnrollments'
import { AppDispatch } from '@/store'

/**
 * Parses a tagline string containing dollar amounts and splits it into parts
 * Supports formats like "$50", "$25-50", "$25 - 50"
 *
 * @param tagline The tagline string to parse
 * @returns An array of string parts, with dollar amounts separated from text
 */
export function parseTagline(tagline: string): string[] {
  const taglineRegex = /(\$\d+(?:\s*-\s*\d+)?)/
  const split = tagline.split(taglineRegex)
  if (split.length === 1) {
    return split
  }
  return split.filter((s) => s.length > 0)
}

export function isDeviceSelectionCompleted(
  program: InProgressUtilityProgramEnrollment,
) {
  return (
    program.selectedDevices.vehicleIds.length > 0 ||
    program.selectedDevices.thermostatIds.length > 0 ||
    program.selectedDevices.chargerIds.length > 0
  )
}

export const invalidateCollections = (dispatch: AppDispatch) =>
  [
    programsNewCollection,
    vehicleEnrollmentCollection,
    thermostatEnrollmentCollection,
    chargerEnrollmentCollection,
    behavioralEnrollmentCollection,
  ].forEach((collection) => dispatch(collection.actions.invalidate()))
